export default '5.23.0';
